import { sunglassesTarget } from "@/lib/unlockPace";
import { useEffect, useState } from "react";
import { toast } from "sonner";

// Sunglasses become a permanent avatar UNLOCK once the user has completed
// 10+ Pomodoros — but they're only actually rendered on Mochi when the user
// has them EQUIPPED (controlled from the Settings panel). The slide-in
// animation only fires the FIRST time the user sees them (tracked in
// localStorage). After that, sunglasses render instantly.
//
//   const { skin, animateSkinIn, sunglassesUnlocked } = useSkinUnlock(settings);
export function useSkinUnlock(settings) {
    const sunglassesUnlocked = (settings?.pomodoros_completed || 0) >= sunglassesTarget(settings);
    // `sunglasses_equipped` defaults to true on the backend, but be defensive
    // here in case settings haven't loaded yet (?? treats undefined as true).
    const sunglassesEquipped = settings?.sunglasses_equipped ?? true;
    const skin = sunglassesUnlocked && sunglassesEquipped ? "sunglasses" : null;
    const [animateSkinIn, setAnimateSkinIn] = useState(false);

    useEffect(() => {
        if (!sunglassesUnlocked) return;
        const seenKey = "mochi-skin-sunglasses-seen";
        if (typeof window !== "undefined" && !window.localStorage.getItem(seenKey)) {
            // Only animate-in when they're actually being shown
            if (sunglassesEquipped) setAnimateSkinIn(true);
            toast("🕶️ Sunglasses unlocked. Toggle them on/off in Settings.", { duration: 6000 });
            try { window.localStorage.setItem(seenKey, "1"); } catch { /* ignore */ }
            const t = setTimeout(() => setAnimateSkinIn(false), 1600);
            return () => clearTimeout(t);
        }
    }, [sunglassesUnlocked, sunglassesEquipped]);

    return { skin, animateSkinIn, sunglassesUnlocked };
}
